import apiClient from '../utils/apiClient';

const reportSettingsEndpoint = '/Reports/Settings';

export const getHourlyReportSettings = async () => {
  try {
    const response = await apiClient.get(`${reportSettingsEndpoint}/Hourly`);
    return response.data;
  } catch (error) {
    console.error('Error fetching hourly report settings:', error);
    throw new Error('Failed to fetch hourly report settings');
  }
};

export const getDailyReportSettings = async () => {
  try {
    const response = await apiClient.get(`${reportSettingsEndpoint}/Daily`);
    return response.data;
  } catch (error) {
    console.error('Error fetching daily report settings:', error);
    throw new Error('Failed to fetch daily report settings');
  }
};

export const setDailyReportHour = async hour => {
  try {
    const response = await apiClient.post(
      `${reportSettingsEndpoint}/Daily/SetHour`,
      { hour } // 👈 body içinde gönderiyoruz
    );
    return response.data;
  } catch (error) {
    console.error('Error setting daily report hour:', error);
    throw new Error('Failed to set daily report hour');
  }
};

export const postHourlyReportSetting = async data => {
  try {
    const response = await apiClient.post(
      `${reportSettingsEndpoint}/Hourly`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error posting hourly report setting:', error);
    throw new Error('Failed to post hourly report setting');
  }
};

export const postDailyReportSetting = async setting => {
  try {
    const response = await apiClient.post(
      `${reportSettingsEndpoint}/Daily`,
      setting
    );
    return response.data;
  } catch (error) {
    console.error('Error posting daily report setting:', error);
    throw new Error('Failed to post daily report setting');
  }
};

export const deleteHourlyReportSetting = async id => {
  try {
    const response = await apiClient.delete(
      `${reportSettingsEndpoint}/Hourly`,
      {
        params: { id },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting hourly report setting with ID ${id}:`, error);
    throw new Error('Failed to delete hourly report setting');
  }
};

export const deleteDailyReportSetting = async id => {
  try {
    const response = await apiClient.delete(`${reportSettingsEndpoint}/Daily`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error(`Error deleting daily report setting with ID ${id}:`, error);
    throw new Error('Failed to delete daily report setting');
  }
};
